<template>
  <v-row>
    <v-card class="mx-auto" width="100%" height="490">
      <v-card-title>
        <a
          v-for="(header, index) in headers"
          :key="index"
          class="text-subtitle-1 font primary--text mt-n6"
        >
          {{ header.title }}
        </a>
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="headers"
        :items="dataCrud"
        :search="search"
        :page.sync="page"
        :items-per-page="itemsPerPage"
        :sort-by="['users_first_surname']"
        :sort-desc="[false]"
        hide-default-footer
        class="elevation-1"
        @page-count="pageCount = $event"
        @click:row="clickTo"
      ></v-data-table>
      <div class="d-flex justify-space-between">
        <v-pagination v-model="page" :length="pageCount"></v-pagination>
        <v-col
          cols="3"
          sm="2"
          md="2"
          lg="1"
          class="d-flex justify-end text-body-2 pt-1"
        >
          <v-dialog-pin :dialogPin="dialogAccountPin" />
        </v-col>
      </div>
    </v-card>
  </v-row>
</template>

<script>
import VDialogPin from '@/components/base/VDialogPin.vue';

export default {
  name: 'VTableProPatient',
  components: {
    VDialogPin,
  },
  props: [
    'headers',
    'dataCrud',
    'clickTo',
    'dialogAccountPin',
  ],
  data() {
    return {
      search: '',
      page: 1,
      pageCount: 0,
      itemsPerPage: 15,
    };
  },
};
</script>